import React from "react";

import { FormControl, Grid, OrderFullDecorator, AppSettings } from "lib/index";

const changeOrderOrderedField = (order, nextOrderedField) => {
  return new OrderFullDecorator({
    ...order,
    ordered_product_order_fields: order.ordered_product_order_fields.map((of) => {
      return of.uuid === nextOrderedField.uuid ? nextOrderedField : of;
    }),
    ordered_product_pricelist_items: order.ordered_product_pricelist_items.map((x) => {
      if (x.ordered_product_order_fields.find((of) => of.uuid === nextOrderedField.uuid)) {
        return {
          ...x,
          ordered_product_order_fields: x.ordered_product_order_fields.map((of) => {
            return of.uuid === nextOrderedField.uuid ? nextOrderedField : of;
          }),
        };
      } else {
        return x;
      }
    }),
    order_customer_participants: order.order_customer_participants.map((x) => {
      if (x.ordered_product_order_fields.find((orderedField) => orderedField.uuid === nextOrderedField.uuid)) {
        return {
          ...x,
          ordered_product_order_fields: x.ordered_product_order_fields.map((orderedField) => {
            return orderedField.uuid === nextOrderedField.uuid ? nextOrderedField : orderedField;
          }),
        };
      } else {
        return x;
      }
    }),
  });
};

export default class OrderCustomerDetailsFormSection extends React.PureComponent {
  state = {
    participantsTouched: false,
  };

  handleOrderPropChange(prop, value) {
    const { order, onChange } = this.props;
    onChange(
      new OrderFullDecorator({
        ...order,
        [prop]: value,
      })
    );
  }

  handleOrderedFieldUpdate(nextOrderedField) {
    const { order, onChange } = this.props;
    let nextOrder = changeOrderOrderedField(order, nextOrderedField);

    // If we're changing participant data, mark participants as touched
    if (nextOrderedField.product_order_field.assignation_type === "assignation_per_person") {
      this.setState({ participantsTouched: true });
    }

    // If participants data aren't touched,
    // and if first participant's full name is the same as customer's,
    // then set his name to the same one as well
    // Do the same for all common customer/participant props
    ["full_name", "email", "phone_number", "birth_date"].forEach((prop) => {
      if (!this.state.participantsTouched && nextOrderedField.product_order_field.preset_id === `customer_${prop}`) {
        const previousValue = order.getPresetOrderFieldValue(`customer_${prop}`);
        if (order.order_customer_participants.length > 0) {
          const participant = order.order_customer_participants[0];
          const participantOrderedField = participant.ordered_product_order_fields.find(
            (of) => of.product_order_field.preset_id === `participant_${prop}`
          );
          if (
            participantOrderedField &&
            participantOrderedField.value === previousValue &&
            nextOrderedField.value !== previousValue
          ) {
            nextOrder = changeOrderOrderedField(nextOrder, {
              ...participantOrderedField,
              value: nextOrderedField.value,
            });
          }
        }
      }
    });

    onChange(nextOrder);
  }

  render() {
    const { order, errors, onBlur } = this.props;
    return (
      <div>
        <Grid columns={2} padded="vertically">
          {order.customer_ordered_fields.map((orderedField) => (
            <Grid.Column key={orderedField.uuid} className="u-paddingTopNone">
              <FormControl.OrderedProductOrderFieldFormGroup
                {...FormControl.addProps(`order.ordered_product_order_fields[${orderedField.uuid}].value`, { errors })}
                value={orderedField}
                showCustomerHint={false}
                onChange={this.handleOrderedFieldUpdate.bind(this)}
                onBlur={onBlur}
                inputRequired={false}
              />
            </Grid.Column>
          ))}

          <Grid.Column className="u-paddingTopNone">
            <FormControl.LocaleSelectFormGroup
              {...FormControl.addProps(`order.customer_locale`, { errors })}
              value={order.customer_locale}
              onChange={this.handleOrderPropChange.bind(this, "customer_locale")}
              onBlur={onBlur}
              label={I18n.humanAttributeName("order", "customer_locale")}
              locales="customer_locales"
            />
          </Grid.Column>
        </Grid>

        {!!order.order_customer_participants.find((p) => p.customer_ordered_fields.length > 0) && (
          <div>
            <h3>{I18n.t("papp.orders.OrderCustomerDetailsFormSection.participants_details")}</h3>
            {order.order_customer_participants.map((participant) => (
              <div key={participant.uuid}>
                <h4>{participant.display_name}</h4>
                <Grid columns={3} padded="vertically">
                  {participant.customer_ordered_fields.map((orderedField) => (
                    <Grid.Column key={orderedField.uuid} className="u-paddingTopNone">
                      <FormControl.OrderedProductOrderFieldFormGroup
                        {...FormControl.addProps(
                          `order.order_customer_participants[${participant.uuid}].ordered_product_order_fields[${orderedField.uuid}].value`,
                          { errors }
                        )}
                        value={orderedField}
                        onChange={this.handleOrderedFieldUpdate.bind(this)}
                        onBlur={onBlur}
                        inputRequired={false}
                      />
                    </Grid.Column>
                  ))}
                </Grid>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/orders/OrderCustomerDetailsFormSection.jsx